import {
  ActionDetail,
  ActionPreview,
  ActionSummary,
  StopActionResponse,
  type CreateActionInput,
} from '@bartizo/shared';
import { apiPageRequest, apiRequest, type Page } from './client.js';

/**
 * Actions (knowledge doc section 12): ban and unban, previewed, confirmed, and
 * followed per server.
 *
 * The preview and the action take the same body, so the dialog sends exactly what
 * it showed; the API checks everything again on the real request.
 */

export const previewAction = (body: CreateActionInput): Promise<ActionPreview> =>
  apiRequest('/actions/preview', { method: 'POST', body, schema: ActionPreview });

export const createAction = (body: CreateActionInput): Promise<ActionDetail> =>
  apiRequest('/actions', { method: 'POST', body, schema: ActionDetail });

export interface ActionFilters {
  server_id?: string;
  cursor?: string;
  limit?: number;
}

export function listActions(filters: ActionFilters = {}): Promise<Page<ActionSummary>> {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== '') params.set(key, String(value));
  }
  const query = params.toString();
  return apiPageRequest(`/actions${query.length > 0 ? `?${query}` : ''}`, {
    schema: ActionSummary,
  });
}

export const getAction = (id: string): Promise<ActionDetail> =>
  apiRequest(`/actions/${encodeURIComponent(id)}`, { schema: ActionDetail });

export const stopAction = (id: string): Promise<StopActionResponse> =>
  apiRequest(`/actions/${encodeURIComponent(id)}/stop`, {
    method: 'POST',
    schema: StopActionResponse,
  });
